export default __webpack_public_path__ + "static/media/hybrid.3ed1e39c.png";